import { forwardRef } from 'react';
import { Loader2 } from 'lucide-react';
import clsx from 'clsx';

const VARIANTS = {
  primary: 'bg-primary text-primary-fg hover:brightness-95 active:brightness-90 disabled:opacity-50',
  secondary: 'border border-border bg-surface text-content hover:bg-surface-2 disabled:opacity-50',
  ghost: 'text-content hover:bg-surface-2 disabled:opacity-50',
  danger: 'bg-danger text-white hover:brightness-95 disabled:opacity-50',
};

const SIZES = {
  md: 'h-touch px-4 text-sm',
  sm: 'h-9 px-3 text-sm',
  lg: 'h-12 px-6 text-base',
};

/** Every size meets the 44px touch target — buttons at a shop counter are tapped, not clicked. */
export const Button = forwardRef(function Button(
  { variant = 'primary', size = 'md', loading = false, className, children, disabled, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      disabled={disabled || loading}
      className={clsx(
        'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-card font-medium transition-colors',
        VARIANTS[variant],
        SIZES[size],
        className,
      )}
      {...props}
    >
      {loading ? <Loader2 size={16} className="animate-spin" aria-hidden="true" /> : null}
      {children}
    </button>
  );
});

export default Button;
